export const decode64 = (string) => atob(string);

export const encode64 = (string) => btoa(string);
